import React, { Component } from "react";
import { Helmet } from "react-helmet-async";
import SliderSec from "./SliderSec/SliderSec";
import PopularTest from "./PopularTest/PopularTest";
import Certification from "./Certification/Certification";

class Home extends Component {
  render() {
    return (
      <>
        <Helmet>
          {/* ===== PRIMARY SEO TITLE ===== */}
          <title>
            Trusted Diagnostic Centre in Punjab | Imaging & Pathology –  Kior Healthcare
          </title>

          {/* ===== META DESCRIPTION (AI + GOOGLE) ===== */}
          <meta
            name="description"
            content="Kior Healthcare is a trusted diagnostic centre in Punjab providing accurate pathology tests, X-ray, CT scan, and advanced imaging services."
          />

          {/* ===== SEARCH ENGINE DIRECTIVES ===== */}
          <meta name="robots" content="index, follow" />
          <meta name="googlebot" content="index, follow" />

          {/* ===== OPEN GRAPH (AI + SOCIAL) ===== */}
          <meta
            property="og:title"
            content="Diagnostic Centre in Punjab – Kior Healthcare"
          />
          <meta
            property="og:description"
            content="Accurate pathology and imaging services including X-ray and CT scan across Punjab."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://kiorhealthcare.com/" />
          <meta
            property="og:image"
            content="https://kiorhealthcare.com/og-image.jpg"
          />

          {/* ===== STRUCTURED DATA (AIO BOOST) ===== */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Kior Healthcare",
              "url": "https://kiorhealthcare.com",
              "logo": "https://kiorhealthcare.com/logo.png",
              "address": {
                "@type": "PostalAddress",
                "addressRegion": "Punjab",
                "addressCountry": "IN"
              },
              "medicalSpecialty": [
                "Diagnostic Radiology",
                "Pathology"
              ],
              "areaServed": {
                "@type": "State",
                "name": "Punjab"
              }
            })}
          </script>
        </Helmet>

        {/* ===== PAGE CONTENT ===== */}
        <SliderSec />
        <PopularTest />
        <Certification />
      </>
    );
  }
}

export default Home;
